module.exports = "<div ng-if=\"item()\">{{ item().getPropertyInfo().getDisplayKeyFromAvailableValuesByCode(item().getValue()) }}</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-form/templates/typekey.html
// module id = 441
// module chunks = 0